var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "section operations" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.cooperateEdit,
                expression: "cooperateEdit"
              }
            ],
            staticClass: "triggers"
          },
          [
            _c(
              "cargo-button-group-slider",
              [
                _c(
                  "el-button",
                  {
                    attrs: { no: "1", type: "primary", disabled: _vm.isEdit },
                    on: { click: _vm.autoAllocateCargoHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.AutoDistribution")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { no: "2", type: "primary", disabled: _vm.isEdit },
                    on: { click: _vm.allocateCargoHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.ManualDistribution")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "3",
                      type: "primary",
                      disabled: !_vm.btUnlockEnabled
                    },
                    on: { click: _vm.removeRelationHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.Unlock2")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isEdit,
                        expression: "!isEdit"
                      }
                    ],
                    attrs: {
                      no: "4",
                      type: "primary",
                      disabled:
                        (!!_vm.job.uuid && !_vm.readonly) || _vm.otherCheck
                    },
                    on: { click: _vm.addWarehouseInHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.InputWarehouseData")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isEdit,
                        expression: "!isEdit"
                      }
                    ],
                    attrs: {
                      no: "5",
                      type: "primary",
                      disabled:
                        (!!_vm.job.uuid && !_vm.readonly) || _vm.otherCheck
                    },
                    on: { click: _vm.editWarehouseInHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.EditWarehouseData")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isEdit,
                        expression: "!isEdit"
                      }
                    ],
                    attrs: {
                      no: "6",
                      type: "primary",
                      disabled:
                        (!!_vm.job.uuid && !_vm.readonly) || _vm.otherCheck
                    },
                    on: { click: _vm.deleteWarehouseData }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.DeleteWarehouseData")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "goodsArrived",
                      type: "primary",
                      disabled: !!_vm.job.uuid && !_vm.readonly
                    },
                    on: { click: _vm.goodsArrivedHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_GoodsArrived")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "outboundOrder",
                      type: "primary",
                      disabled:
                        (!!_vm.job.uuid && !_vm.editOther) ||
                        Boolean(_vm.job.outboundStatus)
                    },
                    on: { click: _vm.outboundOrderHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OutboundOrder")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "cancelOutboundOrder",
                      type: "primary",
                      disabled:
                        (!!_vm.job.uuid && !_vm.editOther) ||
                        Boolean(!_vm.job.outboundStatus)
                    },
                    on: { click: _vm.cancelOutboundOrderHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CancelOutboundOrder")))]
                )
              ],
              1
            ),
            _c(
              "p",
              {
                staticClass: "preserve-space",
                staticStyle: {
                  "flex-grow": "1",
                  "text-align": "right",
                  "margin-top": "0px"
                }
              },
              [
                _c("span", { staticStyle: { color: "red" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.job.outboundStatus
                        ? _vm.$t("CargoMsg.Cargo_OutboundInstructionIssued")
                        : ""
                    )
                  )
                ]),
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("SeaExport.itemCount")) +
                    " : " +
                    _vm._s(_vm.total.itemCount) +
                    " / " +
                    _vm._s(_vm.total.actualItemCount) +
                    " " +
                    _vm._s(_vm.$t("SeaExport.Weight")) +
                    " KGS: " +
                    _vm._s(_vm.total.weight) +
                    " / " +
                    _vm._s(_vm.total.actualWeight) +
                    " " +
                    _vm._s(_vm.$t("SeaExport.Cubage")) +
                    " CBM: " +
                    _vm._s(_vm.total.cubage) +
                    " / " +
                    _vm._s(_vm.total.actualCubage) +
                    " "
                )
              ]
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticStyle: { height: "100%" } },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", height: "100%" },
            attrs: {
              "config-module": "190004",
              "grid-options": _vm.gridOptions,
              "grid-params": _vm.gridParams,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              },
              gridReady: function(params) {
                return (_vm.gridApi = params.api)
              }
            }
          })
        ],
        1
      ),
      _c("warehouse-record-dialog", {
        attrs: { visible: _vm.warehouseRecordDialog.visible, lob: _vm.job.lob },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.warehouseRecordDialog, "visible", $event)
          },
          selectWarehouseHandler: _vm.selectWarehouseHandler
        }
      }),
      _c("warehouse-in-detail-dialog", {
        attrs: {
          visible: _vm.warehouseInDetailDialog.visible,
          action: _vm.action,
          context: _vm.context,
          job: _vm.warehouseInDetailDialog.job,
          warehouse: _vm.warehouseInDetailDialog.warehouse,
          title: _vm.warehouseInDetailDialog.title,
          "open-imperial": _vm.openImperial
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.warehouseInDetailDialog, "visible", $event)
          },
          commit: _vm.commit,
          winClose: _vm.winClose
        }
      }),
      _c("picture-view-window", {
        attrs: {
          visible: _vm.pictureView.visible,
          job: _vm.job,
          model: _vm.pictureView.model,
          title: _vm.pictureView.title,
          "file-name": _vm.pictureView.fileName,
          type: _vm.pictureView.type
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.pictureView, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }